// extracted by mini-css-extract-plugin
module.exports = {"column_text":"BondsIntro_column_text__uQKUk","title":"BondsIntro_title__lBJ0t"};